import { useQuery } from '@tanstack/react-query'
import { ClientUserService } from '../services'
import { UserClientDto } from '../types'
import { defaultQueryOptions } from './common'

export const useClientUser = (locationId: string, userId: string) => {
  return useQuery<UserClientDto>({
    queryKey: ['clientUser', locationId, userId],
    queryFn: () => {
      if (!userId) {
        return Promise.resolve({
          isLoading: false,
          isSuccess: true,
          data: null,
        } as unknown as Promise<UserClientDto>)
      }
      return ClientUserService.get(locationId, userId)
    },
    enabled: !!locationId,
    ...defaultQueryOptions,
  })
}
